module.exports = __webpack_public_path__ + "static/media/oval-diconnected.25db57b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/oval-diconnected.svg
// module id = 849
// module chunks = 21